import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["data-test-id", "disabled", "hideIcon", "onClick", "size", "text", "tooltip", "use", "usageTracker"];
import { useCallback, useMemo } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { CopilotBaseButton } from './internal/CopilotBaseButton';
import { CopilotBaseIconButton } from './internal/CopilotBaseIconButton';
import { cloneTracker } from '../../utils/UsageTracker';
import { useSendCopilotAction } from 'copilot-toolkit/hooks/useSendCopilotAction';
import { jsx as _jsx } from "react/jsx-runtime";
const CopilotActionButton = _ref => {
  let {
      'data-test-id': dataTestId,
      disabled,
      hideIcon = false,
      onClick,
      size = 'sm',
      text = '',
      tooltip,
      use = 'tertiary-light',
      usageTracker
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const aiTracker = useMemo(() => {
    if (usageTracker) {
      return cloneTracker(usageTracker);
    }
    return undefined;
  }, [usageTracker]);
  const sendCopilotAction = useSendCopilotAction();

  // Backwards compatiblity so we can swap the prop name
  const messageAction = rest.copilotAction ? rest.copilotAction : rest.chatspotAction;
  const onSubmitAction = useCallback(event => {
    sendCopilotAction({
      messageAction
    });
    if (aiTracker) {
      aiTracker.track('copilotActionButtonInteraction', {
        type: messageAction.intent || ''
      });
    }
    if (onClick) {
      onClick(event);
    }
  }, [messageAction, onClick, sendCopilotAction, aiTracker]);
  return /*#__PURE__*/_jsx(UITooltip, {
    disabled: disabled,
    title: tooltip || /*#__PURE__*/_jsx(FormattedMessage, {
      message: "aiComponentsUiLibrary.components.copilotActionButton.tooltip"
    }),
    children: text !== '' ? /*#__PURE__*/_jsx(CopilotBaseButton, {
      "data-test-id": dataTestId,
      disabled: disabled,
      hideIcon: hideIcon,
      onClick: onSubmitAction,
      size: size,
      use: use,
      children: text
    }) : /*#__PURE__*/_jsx(CopilotBaseIconButton, {
      "data-test-id": dataTestId,
      disabled: disabled,
      onClick: onSubmitAction,
      size: size,
      use: use
    })
  });
};
export default CopilotActionButton;